<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-form class="mt-4" v-on:submit.prevent="obtenerProductos">
      <b-row>
        <b-col class="text-left">
          <label>Especialidad:</label>
          <b-form-select
            v-model="selectedCategoria"
            :options="optionsCategoria"
            value-field="id"
            text-field="descripcion"
            :state="selectedCategoria != null"
            required
          >
          </b-form-select>
          <b-form-invalid-feedback>
            Debe escoger una opción
          </b-form-invalid-feedback>
        </b-col>
        <b-col class="text-left">
          <label>Tipo:</label>
          <b-form-select
            v-model="selectedTipo"
            :options="optionsTipo"
            value-field="idTipoProducto"
            text-field="descripcion"
            :state="selectedTipo != null"
            required
          >
          </b-form-select>
          <b-form-invalid-feedback>
            Debe escoger una opción
          </b-form-invalid-feedback>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button type="submit" class="mt-4" variant="outline-primary">
            Buscar
          </b-button>
        </b-col>
      </b-row>
    </b-form>

    <b-row>
      <b-col cols="5" class="text-left">
        <label>Búsqueda:</label>
        <b-form-input
          v-model="producto"
          type="search"
          placeholder="Nombre del producto"
        >
        </b-form-input>
      </b-col>
      <b-col>
        <b-button variant="primary" v-if="enviando" disabled>
          <b-spinner small></b-spinner>
          Cargando...
        </b-button>
        <div v-else>
          <label> Número de orden: {{ folioKepler }} </label>
          <br />
          <b-button
            variant="outline-primary"
            v-on:click="crearOrdenRequisicionProductos"
          >
            Guardar
          </b-button>
        </div>
      </b-col>
    </b-row>

    <b-row class="mt-4">
      <b-col v-if="cargandoProductos">
        <b-button variant="primary" disabled>
          <b-spinner small></b-spinner>
          Cargando...
        </b-button>
      </b-col>
      <b-col class="text-left" cols="5" v-else>
        <b-alert v-if="itemsDisponibles.length == 0" variant="danger" show
          >No hay datos</b-alert
        >
        <div v-else>
          <b-table
            striped
            hover
            thead-tr-class="columnas"
            :items="itemsDisponibles"
            :fields="fieldsDisponibles"
            :filter="producto"
            :per-page="perPage"
            :current-page="currentPage"
          >
            <template v-slot:cell(agregar)="row">
              <b-button
                v-b-popover.hover.right="'agregar'"
                variant="outline-primary"
                v-on:click="agregarProducto(row.item)"
              >
                <b-icon icon="arrow-right-short"> </b-icon>
              </b-button>
            </template>
          </b-table>
          <b-pagination
            v-model="currentPage"
            :total-rows="itemsDisponibles.length"
            :per-page="perPage"
          ></b-pagination>
        </div>
      </b-col>
      <b-col>
        <b-alert v-if="itemsAgregados.length == 0" variant="danger" show
          >No hay datos</b-alert
        >
        <div v-else>
          <b-table
            striped
            hover
            thead-tr-class="columnas"
            :items="itemsAgregados"
            :fields="fieldsAgregados"
            :per-page="perPageAgregados"
            :current-page="currentPageAgregados"
          >
            <template v-slot:cell(cantidad)="row">
              <b-form-input
                v-model="row.item.cantidad"
                type="number"
                placeholder="Ingresa la cantidad"
              ></b-form-input>
            </template>
            <template v-slot:cell(stock)="row">
              <b-form-input
                v-model="row.item.stock"
                type="number"
                placeholder="Ingresa el stock"
              ></b-form-input>
            </template>
            <template v-slot:cell(seleccionado)="row">
              <b-button
                v-b-popover.hover.right="'quitar'"
                variant="outline-primary"
                v-on:click="quitarTodo(row.index)"
              >
                <b-icon icon="arrow-left-short"> </b-icon>
              </b-button>
            </template>
          </b-table>
          <b-pagination
            v-model="currentPageAgregados"
            :total-rows="itemsAgregados.length"
            :per-page="perPageAgregados"
          ></b-pagination>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VueNotifications from "vue-notifications";

export default {
  name: "NuevaSolicitud",
  props: {
    ordinario: {
      type: Boolean,
      require: true,
    },
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    optionsCategoria: [],
    optionsTipo: [],
    selectedCategoria: null,
    selectedTipo: null,
    producto: null,
    folioKepler: null,
    perPage: 10,
    currentPage: 1,
    perPageAgregados: 10,
    currentPageAgregados: 1,
    itemsAgregados: [],
    fieldsDisponibles: [
      {
        key: "descripcion",
        label: "Descripción",
        sortable: true,
      },
      {
        key: "agregar",
        label: "Agregar",
      },
    ],
    fieldsAgregados: [
      {
        key: "descripcion",
        label: "Descripción",
      },
      {
        key: "cantidad",
        label: "Cantidad",
      },
      {
        key: "stock",
        label: "Stock",
      },
      {
        key: "seleccionado",
        label: "Seleccionado",
      },
    ],
    itemsDisponibles: [],
    cargandoProductos: false,
    enviando: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.folioKepler =
      "DEN" + this.$moment(new Date()).format("YYYYMMDDHHMMSS");
    this.obtenerCatalogos();

    if (this.ordinario) {
      this.alertarHorario();
    }
  },
  methods: {
    alertarHorario() {
      this.$swal({
        icon: "warning",
        title: "¡Recuerda!",
        text:
          "El levantamiento de requisición son los días: Martes 12:00 AM a sábado 15:00 hrs",
        confirmButtonText: "OK",
        confirmButtonColor: "#0e6ba9",
      });
    },
    obtenerCatalogos() {
      let peticion = this.$api + "catalogos/listaCategoriaProductos";
      this.$http.get(peticion).then((response) => {
        this.optionsCategoria = response.data.data;
      });
      peticion = this.$api + "catalogos/listaTipoProducto";
      this.$http.get(peticion).then((response) => {
        this.optionsTipo = response.data.data;
      });
    },
    obtenerProductos() {
      this.cargandoProductos = true;
      let peticion = this.$api + "requisiciones/productos";
      this.$http
        .post(peticion, this.traerDatosBusqueda())
        .then((response) => {
          this.cargandoProductos = false;
          this.itemsDisponibles = response.data.data;
        })
        .catch((err) => {
          this.cargandoProductos = false;
          this.errorMensaje(err);
        });
    },
    traerDatosBusqueda() {
      return {
        ordinario: this.ordinario,
        idCategoria: this.selectedCategoria,
        idTipoProducto: this.selectedTipo,
      };
    },
    agregarProducto(producto) {
      let existente = false;
      this.itemsAgregados.forEach((i) => {
        if (producto.idProducto === i.idProducto) {
          existente = true;
        }
      });

      if (existente) {
        this.$swal({
          icon: "error",
          text: "Este producto ya existe en la lista",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });
      } else {
        this.itemsAgregados.push(producto);
      }
    },
    quitarTodo(index) {
      this.itemsAgregados.splice(index, 1);
    },
    crearOrdenRequisicionProductos() {
      if (this.itemsAgregados.length == 0) {
        this.$swal({
          icon: "error",
          text: "Por favor agrega una orden de productos",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });
        return false;
      }

      this.enviando = true;
      let peticion = this.$api + "requisiciones";
      this.$http
        .post(peticion, this.traerDatosOrden())
        .then((response) => {
          if (response.status === 200) {
            this.$swal({
              icon: "success",
              text: "Se creo la orden de productos correctamente",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
            setTimeout(() => location.reload(), 2000);
          }
        })
        .catch((error) => {
          this.errorEnvio(error);
        })
        .finally(() => {
          this.enviando = false;
        });
    },
    traerDatosOrden() {
      this.itemsAgregados = this.itemsAgregados.map((it) => ({
        cantidadAutorizada: it.cantidad,
        ...it,
      }));

      return {
        idClinica: this.$localStorageService.getIdClinica(),
        numeroOrden: this.folioKepler,
        idUsuarioRecibe: this.$localStorageService.getIdUsuario(),
        productos: this.itemsAgregados,
        idEmpleado: this.$localStorageService.getIdEmpleado(),
      };
    },
  },
  notifications: {
    errorMensaje: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al traer la información",
    },
    errorEnvio: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al enviar la información",
    },
  },
};
</script>

<style>
</style>